{
  "concept": ["R33", "F38", "F39", "F40", "T2", "T13"],
  "placeholder": true,
  "note": "Bindungspaket Phase 4 (Lead-Auftrag, Fabi, 15.10.2026; docs/bindung.md Nr. 1, 2, 4, 12). Texte von Claude, zum Mitschreiben in docs/bindungstexte.md. {name} ist der Freund, um den es geht, {freund} ein anderer Freund an Bord. Abschied statt Tod (T2), ganze, warme Sätze (T13).",
  "species": {
    "dachs": {
      "intro": [
        "Ich bin {name}. Ich rede nicht viel, aber wenn es draußen ungemütlich wird, grabe ich uns schneller eine Mulde, als ihr „Sturm“ sagen könnt.",
        "Hallo, ich bin {name}. Ich mag es, wenn alles seine Ordnung hat, und ich stelle mich gern vorne hin, damit die anderen in Ruhe arbeiten können."
      ],
      "lastWords": [
        "Lasst nur, meine Pfoten tragen mich heute nicht mehr bis zum Beiboot. Am Hang da drüben riecht es nach einem alten Bau, dort komme ich schon unter. {freund}, du passt mir auf die anderen auf, ja?",
        "Ich bleibe hier und grabe mich ein, bis der Sturm vorbei ist. Wenn ihr im Frühling wieder vorbeikommt, schaut nach dem Bau mit dem krummen Eingang, da wohne ich dann."
      ]
    },
    "igel": {
      "intro": [
        "Ich bin {name}. Wenn ich mich einrolle, hat das nichts mit Angst zu tun, so höre ich einfach besser, was um mich herum passiert.",
        "Hallo, ich bin {name}. Ich bin ein bisschen stachelig, aber wer mich kennt, weiß, dass ich sehr gern kuschle, nur eben vorsichtig."
      ],
      "lastWords": [
        "Ich rolle mich jetzt unter das Laub da drüben und ruhe mich lange aus, so lange, bis der Winter vorbei ist. Fahrt weiter, ihr schafft das auch ohne mich.",
        "{freund}, sei nicht traurig. Ein Igel findet immer einen Laubhaufen, und dieser hier sieht besonders gemütlich aus."
      ]
    },
    "eichhoernchen": {
      "intro": [
        "Hallo, hallo, ich bin {name}! Ich klettere auf jeden Baum, den ihr mir zeigt, und wenn ihr Hunger habt, weiß ich bestimmt noch, wo ich Nüsse versteckt habe. Ungefähr jedenfalls.",
        "Ich bin {name}, und von oben sehe ich alles! Wenn ihr wissen wollt, was hinter der nächsten Biegung liegt, fragt einfach mich."
      ],
      "lastWords": [
        "Ich klettere noch ein letztes Mal ganz nach oben und winke euch nach, solange ich euch sehen kann! Und wenn ihr Hunger habt, im dritten Baum hinter der Biegung liegen Nüsse, glaube ich.",
        "Ich bleibe in diesem Wald, der hat so schöne hohe Bäume. {freund}, du darfst meine Nussverstecke haben, alle, auch die, die ich vergessen habe."
      ]
    },
    "eisvogel": {
      "intro": [
        "Ich bin {name}. Ich sitze gern still auf einem Ast und schaue ins Wasser, bis ich genau weiß, wohin ich muss, und dann bin ich schneller dort als jeder andere.",
        "Mein Name ist {name}. Mein Gefieder glänzt, ich weiß, aber am liebsten bin ich trotzdem dort, wo es ruhig ist und das Wasser klar."
      ],
      "lastWords": [
        "Ich setze mich auf den Ast über dem Wasser und schaue euch nach, bis das Floß hinter der Biegung verschwindet. Haltet die Augen offen, vielleicht seht ihr mich im Frühling wieder blitzen.",
        "Weit fliegen kann ich heute nicht mehr, aber dieser Bach hier ist klar und ruhig. {freund}, fang du für mich den nächsten Fisch."
      ]
    },
    "wasserspitzmaus": {
      "intro": [
        "Ich bin {name}, und ich habe eigentlich immer Hunger. Wenn ihr mir ab und zu etwas abgebt, beiße ich dafür jedem Sturmwesen ordentlich in den Zeh.",
        "Hallo, ich bin {name}! Ich bin klein und schnell und tauche durch jeden Bach, und wer mich unterschätzt, merkt es meistens zu spät."
      ],
      "lastWords": [
        "Ich bin so müde, dass ich nicht einmal mehr Hunger habe, und das heißt bei mir wirklich etwas. Lasst mich hier am Ufer, ich finde schon ein trockenes Loch.",
        "{freund}, iss für mich mit, ja? Ich bleibe hier am Bach und tauche wieder, sobald ich kann."
      ]
    },
    "waschbaer": {
      "intro": [
        "Ich bin {name}. Ich komme von weit her und habe hier am Fluss ein Zuhause gefunden, darum passe ich gut auf alle auf, die mit mir unterwegs sind.",
        "Hallo, ich bin {name}. Wenn sich jemand verletzt, wasche ich die Wunde aus, ganz gründlich, das dauert ein bisschen, hilft aber immer."
      ],
      "lastWords": [
        "Diesmal kann ich die Wunde nicht selbst auswaschen. Geht nur weiter, ich bleibe hier, und ihr passt jetzt gegenseitig aufeinander auf, so wie ich es euch gezeigt habe.",
        "Ich habe schon einmal ein neues Zuhause gefunden, also schaffe ich das auch ein zweites Mal. {freund}, du weißt, wie man gründlich wäscht, mach es gut."
      ]
    },
    "elster": {
      "intro": [
        "Ich bin {name}, und ja, ich mag alles, was glänzt. Ich nehme nichts, was jemandem fehlt, versprochen, nur das, was die Sturmwesen ohnehin nicht verdient haben.",
        "Hallo, ich bin {name}! Ich rede viel und laut, ich weiß, aber dafür findet ihr mit mir mehr Schätze als je zuvor."
      ],
      "lastWords": [
        "Ausgerechnet jetzt, wo ich so viel Glänzendes gefunden habe! Behaltet alles, ich bleibe hier im Baum und erzähle den anderen Elstern, was für eine Truppe ihr seid.",
        "{freund}, das kleine glänzende Ding in meinem Versteck gehört jetzt dir. Pass gut darauf auf, vielleicht hole ich es mir im Frühling wieder."
      ]
    },
    "feuersalamander": {
      "intro": [
        "Ich bin {name}. Ich bin nicht der Schnellste, aber ich bleibe stehen, wo andere weglaufen, und wer mich beißt, bereut es.",
        "Hallo, ich bin {name}. Ich bin ganz ruhig und mag die Nacht, und wenn ihr alle schlaft, halte ich gern Wache."
      ],
      "lastWords": [
        "Ich krieche unter den Stein dort, da ist es feucht und kühl. Ich bin langsam, aber zäh, und im Frühling bin ich wieder da, ganz bestimmt.",
        "{freund}, halt heute Nacht für mich Wache, ja? Ich bleibe hier im Moos und ruhe mich aus."
      ]
    },
    "biber": {
      "intro": [
        "Ich bin {name}. Wenn etwas kaputt ist, sagt mir Bescheid; wenn nichts kaputt ist, baue ich trotzdem etwas.",
        "Hallo, ich bin {name}. Ich klatsche mit dem Schwanz, wenn Gefahr droht, dann wisst ihr Bescheid."
      ],
      "lastWords": [
        "Fahrt ohne mich weiter, ich baue mir hier am Ufer einen Damm, der hält. {freund}, pass auf das Floß auf, ja? Es knarzt hinten links.",
        "Ich bleibe hier. Wenn ihr im Frühling vorbeikommt, schaut nach dem Damm mit dem schiefen Ast, da wohne ich dann."
      ]
    },
    "fuchs": {
      "intro": [
        "Ich bin {name}. Ich weiß immer, wo es langgeht, und wenn nicht, tue ich so.",
        "Hallo, ich bin {name}. Beim Händler lasst mich reden, das lohnt sich."
      ],
      "lastWords": [
        "Ich finde schon einen Weg, das tue ich immer. {freund}, versprich mir, dass du beim nächsten Händler nicht den vollen Preis zahlst.",
        "Fahrt weiter, ich schlage mich durch. Ein Fuchs kommt immer irgendwo an."
      ]
    },
    "otter": {
      "intro": [
        "Ich bin {name}! Wollen wir Freunde sein? Ich halte gern Pfoten.",
        "Hallo, ich bin {name}. Ich schwimme, ich spiele, und ich passe auf, dass niemand allein ist."
      ],
      "lastWords": [
        "Ich lasse mich ein Stück treiben, das kann ich gut. {freund}, halt für mich die Pfote von jemand anderem, ja?",
        "Der Fluss trägt mich schon. Vielleicht sehen wir uns am Meer wieder."
      ]
    }
  },
  "reactions": [
    "{freund} schaut noch lange zum Ufer zurück, bis es hinter der Biegung verschwindet.",
    "{freund} sagt eine ganze Weile nichts und rückt dann ein Stück näher an die anderen heran.",
    "{freund} flüstert: „Bis zum Frühling, {name}“, und dreht sich erst weg, als das Ufer nicht mehr zu sehen ist.",
    "{freund} legt ein buntes Blatt an die Stelle, an der {name} immer gesessen hat."
  ],
  "memories": {
    "start": "war von Anfang an dabei",
    "bewerbung": "hat sich mit einem Brief bei euch beworben",
    "befreit": "wurde von einer Sturmklette befreit und blieb bei euch",
    "ereignis": "kam bei „{wo}“ an Bord",
    "auftrag": "kam mit {wer} von einem Auftrag zurück und blieb",
    "title": "bekam den Titel „{titel}“",
    "boss": "hat am Durchlass den großen Treibholzer vertrieben",
    "promise": "kam dank des Versprechens angeschlagen zurück",
    "errand": "war beim Auftrag „{auftrag}“ unterwegs",
    "lastStanding": "hielt am Ende allein das Ufer"
  }
}
